import { createContext, useContext, useEffect, useState } from "react";
import { api, setToken, getToken } from "@/lib/api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, obj = auth
  const [ready, setReady] = useState(false);

  useEffect(() => {
    const st = new URLSearchParams(window.location.search).get("support_token");
    if (st) { setToken(st); window.history.replaceState({}, "", window.location.pathname); }
    if (!getToken()) {
      setUser(false);
      setReady(true);
      return;
    }
    api.me()
      .then((u) => setUser(u))
      .catch(() => { setToken(null); setUser(false); })
      .finally(() => setReady(true));
  }, []);

  const login = async (email, password) => {
    const res = await api.login(email, password);
    setToken(res.token);
    setUser(res.user);
    return res.user;
  };

  const pinLogin = async (slug, pin, employeeCode) => {
    const res = await api.pinLogin(slug, pin, employeeCode);
    setToken(res.token);
    setUser(res.user);
    return { ...res.user, must_set_pin: !!(res.must_set_pin || res.user?.pin_temporary) };
  };

  const refreshUser = async () => { try { const u = await api.me(); setUser(u); return u; } catch { return null; } };

  const emailLogin = async (email, password) => {
    const res = await api.login(email, password);
    setToken(res.token);
    setUser(res.user);
    return res.user;
  };

  const logout = async () => {
    try { await api.logout(); } catch (e) {}
    setToken(null);
    setUser(false);
  };

  return <AuthCtx.Provider value={{ user, ready, login, pinLogin, refreshUser, emailLogin, logout }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
